<template>
  <div class="background">
    <div class="overlay">
        <v-container class="form-container">
            <v-row
            align="center"
            justify="center"
            class="form-row pt-15"
            no-gutters
            >
                <v-card class="pa-5 rounded-xl" elevation="0">
                    <v-tabs
                    v-model="tabs"
                    background-color="transparent"
                    color="blueDark"
                    dark
                    class="tabs"
                    fixed-tabs
                    >
                        <v-tab>
                            <v-icon left>mdi-airplane</v-icon>
                            <span class="font-weight-medium body-1">Flights</span>
                        </v-tab>
                        <v-tab>
                            <v-icon left>mdi-bed</v-icon>
                            <span class="font-weight-medium body-1">Hotels</span>
                        </v-tab>
                        <v-tab>
                            <v-icon left>mdi-car</v-icon>
                            <span class="font-weight-medium body-1">Cars</span>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabs" style="background: transparent;" class="mt-2">
                        <v-tab-item>
                            <flightSearch></flightSearch>
                        </v-tab-item>
                        <v-tab-item>
                            <hotelSearch></hotelSearch>
                        </v-tab-item>
                        <v-tab-item>
                            <carSearch/>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
                <!-- <v-col cols="12" class="form-col">
                    <v-tabs
                    v-model="tabs"
                    background-color="transparent"
                    color="orange"
                    dark
                    class="tabs"
                    >
                        <v-tab>
                            <v-icon left>mdi-airplane</v-icon>
                            <span class="font-weight-bold body-1">Flights</span>
                        </v-tab>
                        <v-tab>
                            <v-icon left>mdi-bed</v-icon>
                            <span class="font-weight-bold body-1">Hotels</span>
                        </v-tab>
                        <v-tab>
                            <v-icon left>mdi-car</v-icon>
                            <span class="font-weight-bold body-1">Cars</span>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabs" style="background: transparent;" class="mt-5">
                        <v-tab-item>
                            <flightSearch></flightSearch>
                        </v-tab-item>
                        <v-tab-item>
                            <hotelSearch></hotelSearch>
                        </v-tab-item>
                        <v-tab-item>
                            <carSearch/>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col> -->
            </v-row>
        </v-container>
    </div>
  </div>
</template>

<script>
import flightSearch from './flightSearch.vue'
import hotelSearch from './hotelSearch.vue'
import carSearch from './carSearch.vue'

export default {
  components: {
    flightSearch,
    hotelSearch,
    carSearch
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>

<style>
    .background {
        height: 100%;
        min-height: 60vh;
        background: url('../static/bg1.jpg');
        background-size: cover;
        background-position: center center;
    }
    .overlay {
        min-height: 60vh;
        height: 100%;
        width: auto;
        position: relative;
    }
    /* .form-container {
        min-height: 60vh;
    } */
    .form-row {
        /* min-width: 100%; */
        min-height: 60vh;
    }
    /* .form-col {
        margin-top: 100px;
        padding-right: 3px;
        padding-left: 3px;
        background-color: #fff;
        background-color: rgb(31 52 99 / 55%);
        border-radius: 8px;
    } */
    .tabs {
        /* border-bottom: white 1px solid; */
        border-bottom: #ccc 1px solid;
        margin-top: 20px;
        transform: translateY(-5px);
    }
    .v-tab span, .v-tab i {
        color: #333;
    }
    .v-tab.v-tab--active span {
        color: #2F80C2;
    }
    .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled {
        color: #333 !important;
    }
    /* @media screen and (max-width: 1265px) {
        .col {
            padding-right: 26px;
        }
    }
    @media screen and (max-width: 959.5px) {
        .col {
            padding-right: 2px;
        }
    } */
</style>
